import { $fetch } from 'vfetcher/ofetch'
// OLD: router was only used for the silent redirect on 401/403 below
// import router from "@/router";
import { getUser } from "@/store/auth/state.js";
import { useToast } from "primevue/usetoast";
// NEW: 401/403 show the blocking SessionExpiredModal once instead of a
// silent redirect — see services/error/sessionExpired.js
import { triggerSessionExpired } from "@/services/error/sessionExpired.js";

export default {
  install: (app, options) => {
    app.config.globalProperties.$apiDougJones = $fetch.create({
      baseURL: '/api',
      headers:{        
        "Dougjones": "web",
      },
      onRequest({ request, options }) {
        // Only log API requests in development mode
        if (import.meta.env.MODE === 'development') {
          // console.log("Intercepted API", request);
        }
      },
      async onResponseError({ response }) {
        // OLD: silently redirected home — user never learned the session died,
        // and every parallel failing call re-triggered the redirect.
        // if (response.status === 401) {
        //   router.push('/');
        // }
        // else if (response.status === 403) {
        //   router.push('/');
        // }

        // NEW: show the SessionExpiredModal popup once ("Log In" → /sign-in)
        if (response.status === 401 || response.status === 403) {
          triggerSessionExpired();
        }
      }
    })
  }
}
